import { useEffect, useCallback } from "react";
import { useBlockNumber, useGetMainNetwork } from "../state/application/hooks";
import useActiveWeb3React from "./useActiveWeb3React";

export function useResultContract(info: () => void, dependence: any[]) {
  const mainNetwork = useGetMainNetwork();
  const latestBlockNumber = useBlockNumber();
  const { chainId, account } = useActiveWeb3React();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const func = useCallback(info, [
    latestBlockNumber,
    account,
    chainId,
    mainNetwork,
    ...dependence,
  ]);
  useEffect(() => {
    func();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestBlockNumber, account, chainId, mainNetwork, ...dependence]);
}
